/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'app-navigate-wizard',
  templateUrl: './navigate-wizard.component.html',
  styleUrls: ['./navigate-wizard.component.scss']
//   animations: [
//     trigger('nextVisibility', [
//         state('slideIn', style({
//             transform: 'translateX(0)'
//         })),
//         state('slideOut', style({
//             transform: 'translateX(60%)'
//         })),
//         transition('slideIn => slideOut', [animate('2s ease-in', style({ transform: 'translateX(60%)' }))]),
//         transition('slideOut => slideIn', [animate('2s ease-out', style({ transform: 'translateX(0)' }))])
//     ]),
//     trigger('nextOnlyVisibility', [
//       state('slideIn', style({
//           transform: 'translateX(0)'
//       })),
//       state('slideOut', style({
//           transform: 'translateX(135%)'
//       })),
//       transition('slideIn => slideOut', [animate('2s ease-in', style({ transform: 'translateX(135%)' }))]),
//       transition('slideOut => slideIn', [animate('2s ease-out', style({ transform: 'translateX(0)' }))])
//   ])
//     // trigger('seperatorVisibility', [
//     //     state('slideIn', style({
//     //         transform: 'rotate(0deg) translate(0%)',
//     //         opacity:1
//     //     })),
//     //     state('slideOut', style({
//     //         transform: 'rotate(90deg) translate(135%)',
//     //         opacity:0
//     //     })),
//     //     transition('slideIn => slideOut', [animate('1.7s ease-in', style({ transform: 'rotate(90deg) translate(135%)' }))]),
//     //     transition('slideOut => slideIn', [animate('1.7s ease-out', style({ transform: 'rotate(0deg) translate(0%)', opacity:1 }))])
//     // ])
// ]
})
export class NavigateWizardComponent implements OnInit, OnChanges {
  @Input() state: any;
  @Input() backstate:any;
  @Input() exit:any;
  @Output() back: EventEmitter<any> = new EventEmitter();
  @Output() next: EventEmitter<any> = new EventEmitter();
  public saveState = "slideIn";
  public exitState = false;
  public backBtnState = true;

  constructor(public commonService: CommonService,) { }

  ngOnInit() {
    this.saveState = this.state;
    this.backBtnState = (this.backstate !== undefined)? this.backstate: true;
    this.exitState = (this.exit)? this.exit : false;
  }

  ngOnChanges(changes: any) {
    if (changes.state) {
      this.saveState = changes.state.currentValue;
    }
  }

  public getTranslationWithKey(key: string): string {
    return this.commonService.getTranslatedVal(key);
  }

  public goBack(){
    this.back.emit();
  }

  public goNext(){
    this.next.emit();
  }
}
